import React, { useState } from 'react';
import './TfrxChrome.css';

// ── Marketing site / socials / CTA (edit to taste) ────────────────────────
const SITE = 'https://teamfronx.com';
const STORE_URL = 'https://teamfronx.com/store';
const JOIN_URL = '/signup';                 // header + footer CTA → membership form
const RENEW_URL = 'https://team-fronx-32bbe.web.app/renew';
const ADMIN_URL = 'https://teamfronx.com/admin-login/';
const CTA_LOGO = 'https://teamfronx.com/wp-content/uploads/2026/03/Untitled-1-3.png';
const SOCIALS = {
  instagram: 'https://www.instagram.com/_team_fronx',
  facebook: 'https://www.facebook.com/share/1ArfuoxPbs/?mibextid=wwXIfr',
  youtube: 'https://www.youtube.com/@TEAMFRONX',
};

const NAV_LINKS = [
  { label: 'Home', href: `${SITE}/` },
  { label: 'Features', href: `${SITE}/#features` },
  { label: 'Events', href: `${SITE}/#events` },
  { label: 'Gallery', href: `${SITE}/gallery` },
  { label: 'About', href: `${SITE}/about` },
  { label: 'Contact', href: `${SITE}/contact` },
];

const BagIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
    <path d="M3 6h18" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
);

export function TfrxHeader() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="tfrx-nav">
      <div className="tfrx-container">
        <div className="tfrx-nav-row">
          <a className="tfrx-brand" href={`${SITE}/`}>
            <img className="tfrx-brand-logo" src="/logo.png" alt="Team Fronx" />
            <span className="tfrx-brand-text">Team Fronx</span>
          </a>

          <div className="tfrx-menu">
            {NAV_LINKS.map((l) => (
              <a key={l.label} href={l.href}>{l.label}</a>
            ))}
            <a className="tfrx-nav-store" href={STORE_URL}>
              <BagIcon /> Store
            </a>
            <a className="tfrx-btn tfrx-btn-primary" href={JOIN_URL}>Join Now</a>
          </div>

          <button
            className="tfrx-menu-btn"
            aria-label="Menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="2" strokeLinecap="round">
              <path d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          </button>
        </div>

        <div className={`tfrx-mobile ${open ? 'active' : ''}`}>
          {NAV_LINKS.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)}>
              {l.label}
            </a>
          ))}
          <a className="tfrx-nav-store" href={STORE_URL} onClick={() => setOpen(false)}>
            <BagIcon /> Store
          </a>
          <a className="tfrx-btn tfrx-btn-primary" href={JOIN_URL}
            onClick={() => setOpen(false)}>Join Now</a>
        </div>
      </div>
    </nav>
  );
}

export function TfrxFooter() {
  return (
    <footer className="gf">
      <div className="gf-in">
        <div className="gf-top">
          <p className="gf-desc">
            Team Fronx is <span className="gf-hl">India&apos;s premier community</span> for
            Maruti Fronx owners and enthusiasts, connecting members across the country.
          </p>

          <div className="gf-col">
            <h5>Explore</h5>
            <a href={`${SITE}/`}>Home</a>
            <a href={`${SITE}/#features`}>Features</a>
            <a href={`${SITE}/#events`}>Events</a>
            <a href={`${SITE}/gallery`}>Gallery</a>
          </div>

          <div className="gf-col">
            <h5>The Club</h5>
            <a href={`${SITE}/about`}>About</a>
            <a href={`${SITE}/blog`}>Blog</a>
            <a href={STORE_URL}>Store</a>
            <a href={`${SITE}/contact`}>Contact</a>
          </div>

          <div className="gf-col">
            <h5>Membership</h5>
            <a href={RENEW_URL} target="_blank" rel="noopener noreferrer">Renew Membership</a>
          </div>
        </div>

        <div className="gf-mid">
          <div className="gf-socials">
            <span className="lab">Follow us</span>
            <a className="gf-ic" href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.9" />
                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.9" />
                <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" />
              </svg>
            </a>
            <a className="gf-ic" href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M13.5 21V13.2H16.1L16.5 10.2H13.5V8.3C13.5 7.43 13.75 6.83 15 6.83H16.6V4.15C15.82 4.06 15.03 4.01 14.24 4C11.9 4 10.3 5.43 10.3 8.05V10.2H7.8V13.2H10.3V21H13.5Z" fill="currentColor" />
              </svg>
            </a>
            <a className="gf-ic" href={SOCIALS.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M21 12C21 12 21 8.73 20.58 7.16C20.35 6.3 19.67 5.62 18.81 5.39C17.24 4.97 12 4.97 12 4.97C12 4.97 6.76 4.97 5.19 5.39C4.33 5.62 3.65 6.3 3.42 7.16C3 8.73 3 12 3 12C3 12 3 15.27 3.42 16.84C3.65 17.7 4.33 18.38 5.19 18.61C6.76 19.03 12 19.03 12 19.03C12 19.03 17.24 19.03 18.81 18.61C19.67 18.38 20.35 17.7 20.58 16.84C21 15.27 21 12 21 12Z" stroke="currentColor" strokeWidth="1.6" />
                <path d="M10 15.5V8.5L16 12L10 15.5Z" fill="currentColor" />
              </svg>
            </a>
          </div>

          <div className="gf-ctawrap">
            <div className="gf-cta">
              <span className="gf-cta-logo"><img src={CTA_LOGO} alt="" /></span>
              <span className="gf-cta-text">Ready to join the Fronx family?</span>
              <a href={JOIN_URL} className="tfrx-btn tfrx-btn-primary">
                Join Now
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="gf-tags">
          <span>One Passion &middot; One Family &middot; One Journey</span>
          <span>India &middot; All 28 States</span>
        </div>
      </div>

      <div className="gf-mark">Team Fronx</div>

      <div className="gf-bottom">
        <span>
          <a href={ADMIN_URL} className="tfrx-admin-dot" aria-label="Admin login">&copy;</a>{' '}
          2026 Team Fronx. All rights reserved.<br />Powered by VORTIXA LABS.
        </span>
        <span className="gf-legal">
          <a href={`${SITE}/privacy-policy`}>Privacy Policy</a>
          <a href={`${SITE}/terms`}>Terms of Service</a>
          <a href={`${SITE}/sales-return-policy`}>Sales &amp; Return Policy</a>
        </span>
      </div>
    </footer>
  );
}
